var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwsStepFunctions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_119)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 36,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 36.5,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_119)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 76H180V176H80V76Z",
    fill: "url(#paint0_linear_1_119)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.5 131H162.5V121H137.5V131ZM163.75 118.5H136.25C135.918 118.5 135.601 118.632 135.366 118.866C135.132 119.101 135 119.418 135 119.75V132.25C135 132.582 135.132 132.899 135.366 133.134C135.601 133.368 135.918 133.5 136.25 133.5H163.75C164.082 133.5 164.399 133.368 164.634 133.134C164.868 132.899 165 132.582 165 132.25V119.75C165 119.418 164.868 119.101 164.634 118.866C164.399 118.632 164.082 118.5 163.75 118.5ZM135 154.75C135 156.818 133.318 158.5 131.25 158.5C129.182 158.5 127.5 156.818 127.5 154.75C127.5 152.682 129.182 151 131.25 151C133.318 151 135 152.682 135 154.75ZM97.5 136H120V131H97.5V136ZM97.5 121V116H120V121H97.5ZM127.5 97.25C127.5 95.1825 129.182 93.5 131.25 93.5C133.318 93.5 135 95.1825 135 97.25C135 99.3175 133.318 101 131.25 101C129.182 101 127.5 99.3175 127.5 97.25ZM150 143.5H110V138.5H121.25C121.582 138.5 121.899 138.368 122.134 138.134C122.368 137.899 122.5 137.582 122.5 137.25V129.75C122.5 129.418 122.368 129.101 122.134 128.866C121.899 128.632 121.582 128.5 121.25 128.5H110V123.5H121.25C121.582 123.5 121.899 123.368 122.134 123.134C122.368 122.899 122.5 122.582 122.5 122.25V114.75C122.5 114.418 122.368 114.101 122.134 113.866C121.899 113.632 121.582 113.5 121.25 113.5H110V108.5H150V113.5H152.5V107.25C152.5 106.918 152.368 106.601 152.134 106.366C151.899 106.132 151.582 106 151.25 106H132.5V103.373C135.35 102.793 137.5 100.268 137.5 97.25C137.5 93.805 134.697 91 131.25 91C129.593 91.002 128.004 91.6611 126.833 92.8328C125.661 94.0044 125.002 95.593 125 97.25C125 100.268 127.15 102.793 130 103.373V106H108.75C108.418 106 108.101 106.132 107.866 106.366C107.632 106.601 107.5 106.918 107.5 107.25V113.5H96.25C95.9185 113.5 95.6005 113.632 95.3661 113.866C95.1317 114.101 95 114.418 95 114.75V122.25C95 122.582 95.1317 122.899 95.3661 123.134C95.6005 123.368 95.9185 123.5 96.25 123.5H107.5V128.5H96.25C95.9185 128.5 95.6005 128.632 95.3661 128.866C95.1317 129.101 95 129.418 95 129.75V137.25C95 137.582 95.1317 137.899 95.3661 138.134C95.6005 138.368 95.9185 138.5 96.25 138.5H107.5V144.75C107.5 145.082 107.632 145.399 107.866 145.634C108.101 145.868 108.418 146 108.75 146H130V148.628C127.15 149.208 125 151.732 125 154.75C125 158.195 127.803 161 131.25 161C134.697 161 137.5 158.195 137.5 154.75C137.5 151.732 135.35 149.208 132.5 148.628V146H151.25C151.582 146 151.899 145.868 152.134 145.634C152.368 145.399 152.5 145.082 152.5 144.75V138.5H150V143.5Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_119",
    x: 0,
    y: 0,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_119"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_119",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_119",
    x1: 80,
    y1: 10076,
    x2: 10080,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0084D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4F8B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(80 76)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsStepFunctions);
export default __webpack_public_path__ + "static/media/aws-step-functions.25fdc6d2beda4200d30126fd5ac749ca.svg";
export { ForwardRef as ReactComponent };